const NotificationTypes = {
    0: 'Search',
    1: 'AR',
    2: 'Direct',
    3: 'MGID',
    4: 'Glispa',
    5: 'Message',
    9: 'Initial'
};

export default NotificationTypes;


// WEBPACK FOOTER //
// ./src/data/NotificationsTypes.js